import { render, staticRenderFns } from "./mvxq.vue?vue&type=template&id=74630b9b&scoped=true"
import script from "./mvxq.vue?vue&type=script&lang=js"
export * from "./mvxq.vue?vue&type=script&lang=js"
import style0 from "./mvxq.vue?vue&type=style&index=0&id=74630b9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74630b9b",
  null
  
)

export default component.exports